import { useState, useEffect } from "react";

interface CountdownSectionProps {
  title: string;
  targetDate: string; // ISO date string stored in `content`
  backgroundColor?: string;
}

function getTimeLeft(target: Date) {
  const now = new Date().getTime();
  const diff = target.getTime() - now;
  if (diff <= 0) return null;
  return {
    days: Math.floor(diff / (1000 * 60 * 60 * 24)),
    hours: Math.floor((diff / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((diff / (1000 * 60)) % 60),
    seconds: Math.floor((diff / 1000) % 60),
  };
}

const labels = ["Dias", "Horas", "Minutos", "Segundos"];

export function CountdownSection({ title, targetDate, backgroundColor }: CountdownSectionProps) {
  const target = new Date(targetDate);
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(target));

  useEffect(() => {
    const interval = setInterval(() => {
      const tl = getTimeLeft(target);
      setTimeLeft(tl);
      if (!tl) clearInterval(interval);
    }, 1000);
    return () => clearInterval(interval);
  }, [targetDate]);

  if (!targetDate) return null;

  const values = timeLeft
    ? [timeLeft.days, timeLeft.hours, timeLeft.minutes, timeLeft.seconds]
    : [0, 0, 0, 0];

  return (
    <section
      className="py-10 sm:py-14 px-4"
      style={{ backgroundColor: backgroundColor || undefined }}
    >
      <div className="max-w-3xl mx-auto text-center space-y-6">
        {title && (
          <p className="text-base sm:text-lg font-semibold text-foreground">{title}</p>
        )}

        {timeLeft ? (
          <div className="flex justify-center gap-3 sm:gap-5">
            {values.map((val, i) => (
              <div key={i} className="flex flex-col items-center">
                <div className="w-16 h-16 sm:w-20 sm:h-20 rounded-xl bg-primary/10 border border-primary/20 flex items-center justify-center shadow-sm">
                  <span className="text-2xl sm:text-3xl font-extrabold text-primary tabular-nums">
                    {String(val).padStart(2, "0")}
                  </span>
                </div>
                <span className="text-[10px] sm:text-xs font-medium text-muted-foreground mt-1.5 uppercase tracking-wider">
                  {labels[i]}
                </span>
              </div>
            ))}
          </div>
        ) : (
          <p className="text-lg font-semibold text-destructive">Oferta encerrada</p>
        )}
      </div>
    </section>
  );
}
